/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/house_2'
export default icon
